import React, { Children } from 'react';
import { motion } from 'framer-motion';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
const staggerContainer = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const poomsaeVideos = [{
  id: 'nPjMc3n_JkM',
  title: 'NWBBA POOSAE TAEGEUK II CHANG #1'
}, {
  id: 'a-mGxNoV8rk',
  title: 'NWBBA POOSAE TAEGEUK II CHANG #2'
}, {
  id: '4uML0FC8wQ4',
  title: 'NWBBA POOSAE TAEGEUK II CHANG #3'
}, {
  id: 'aec4MFYJcz0',
  title: 'NWBBA POOSAE TAEGEUK II CHANG #4'
}, {
  id: '4eMyvQprYcg',
  title: 'NWBBA POOSAE TAEGEUK II CHANG #5'
}, {
  id: '3Hd8jZ3oZfs',
  title: 'NWBBA POOSAE TAEGEUK II CHANG #6'
}, {
  id: 'Ghy4rT9VoWw',
  title: 'NWBBA POOSAE TAEGEUK II CHANG #7'
}, {
  id: 'DBttlF8_G4g',
  title: 'NWBBA POOSAE TAEGEUK II CHANG #8'
}, {
  id: 'cWN7lk297Xg',
  title: 'NWBBA POOMSAE KORYO 1ST DAN BLACK BELT'
}, {
  id: 'bA4_gonCufE',
  title: 'NWBBA POOMSAE KEUMGANG 2ND DAN BLACK BELT'
}, {
  id: 'ZkGexCAYcLQ',
  title: 'NWBBA POOMSAE TAEBECK 3RD DAN BLACK BELT'
}];
interface VideoCardProps {
  videoId: string;
  title: string;
}
function VideoCard({
  videoId,
  title
}: VideoCardProps) {
  return <motion.div variants={fadeIn} className="group" data-id="element-713">
      <div className="relative aspect-video bg-gray-900 rounded-lg overflow-hidden shadow-lg border-2 border-[#a3d977]/20" data-id="element-714">
        <iframe src={`https://www.youtube.com/embed/${videoId}`} title={title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="absolute inset-0 w-full h-full" data-id="element-715" />
      </div>
      <h3 className="mt-3 text-sm font-bold text-[#0f1f3d] uppercase tracking-wide" data-id="element-716">
        {title}
      </h3>
    </motion.div>;
}
export function PoomsaeSection() {
  return <section className="py-20 px-4 bg-[#F3F3F3]" data-id="element-717">
      <div className="max-w-7xl mx-auto" data-id="element-718">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} data-id="element-719">
          <div className="text-center mb-12" data-id="element-720">
            <h2 className="text-3xl sm:text-4xl font-black text-[#0f1f3d] mb-2" data-id="element-721">
              Poomsae
            </h2>
            <p className="text-lg text-gray-600 italic" data-id="element-722">With Ellie Whitworth</p>
          </div>

          <motion.div variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-723">
            {poomsaeVideos.map((video, idx) => <VideoCard key={idx} videoId={video.id} title={video.title} data-id="element-724" />)}
          </motion.div>
        </motion.div>
      </div>
    </section>;
}